import { gql } from '@apollo/client'
import { IQueryBasicData, ID } from '../IQueryData'

export interface IStatParkingPoolAvailabilityVars {
  parkingPool: ID
  from: string
  to: string
}

export interface IAvailabilityBuilding {
  id: ID
  name: string
  sort: number
}

export interface IAvailabilityDay {
  day: string
  parkingName: string
  poolParkingId: ID
  buildings: IAvailabilityBuilding[] | null
  capacity: number
  reserved: number
  used: number
  free: number
  overCapacity: boolean
}

export interface IStatParkingPoolAvailabilityData {
  statParkingPoolAvailability: IQueryBasicData & {
    stats: IAvailabilityDay[] | null
  }
}

export const STAT_PARKING_POOL_AVAILABILITY = gql`
  query statParkingPoolAvailability(
    $parkingPool: ID!
    $from: DateTime!
    $to: DateTime!
  ) {
    statParkingPoolAvailability(
      parking_pool: $parkingPool
      from: $from
      to: $to
    ) {
      status
      code
      error
      message
      stats {
        day
        parkingName: parking_name
        poolParkingId: pool_parking_id
        buildings {
          id
          name
          sort
        }
        capacity
        reserved
        used
        free
        overCapacity: over_capacity
      }
    }
  }
`
